module.exports = __webpack_public_path__ + "img/ico-home.da859744.svg";